<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <!-- <dashboard-core-settings /> -->
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'
  // import engine from '@/plugins/engine'

  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('../dashboard/components/core/AppBar'),
      DashboardCoreDrawer: () => import('../dashboard/components/core/Drawer'),
      // DashboardCoreSettings: () => import('../dashboard/components/core/Settings'),
      DashboardCoreView: () => import('../dashboard/components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed: {
      ...mapState(['auth']),
    },
    mounted () {
    },

    created () {

    },
    beforeDestroy () {
    },
    methods: {

    },
  }
</script>
